<h2 mat-dialog-title>
  {{ (mode === 'share' ? 'publish_activity_dialog.share.title' : 'publish_activity_dialog.title') | translate }}
</h2>
<mat-dialog-content>
  <p
    [innerHtml]="(mode === 'share' ? 'publish_activity_dialog.share.description' : 'publish_activity_dialog.description') | translate: {
      organizationUnitTypeName: originalOwner.type | ou_type_name | translate,
      organizationUnitName: originalOwner?.name || ''
    }"
  ></p>
  <p>
    <a (click)="selectOther()" href="javascript:void(0)">
      {{ 'publish_activity_dialog.other.select.button' | translate }}
    </a>
  </p>
  <p><strong>{{ 'publish_activity_dialog.targets.heading' | translate }}</strong></p>
  @if (selectedTargets.length === 0) {
    <p class="empty-state-hint">{{ 'publish_activity_dialog.targets.empty' | translate }}</p>
  } @else {
    <mat-chip-listbox>
      @for (target of selectedTargets; track target.id) {
        <mat-chip-option [removable]="true" (removed)="removeTarget(target.id)">
          {{ target.organization_unit_type_id | ou_type_name | translate }} — {{ target.name }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-option>
      }
    </mat-chip-listbox>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onCancel()">
    {{ 'generic.cancel' | translate | uppercase }}
  </button>
  <span class="spacer"></span>
  <button mat-button color="primary" (click)="onConfirm()">{{ 'generic.ok' | translate }}</button>
</mat-dialog-actions>
